import React from 'react';
import classNames from 'classnames';
import MultiResolutionImage from '@domain-group/fe-co-multi-resolution-image';
import * as styles from './allhomes-listing-card-images.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var DefaultImage = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-co-allhomes-listing-card/static/no-listing-image_02548b65.svg";
function isValid(prop) {
  return prop && prop.length > 0;
}
export var AllhomesListingCardImages = _ref => {
  var listingImage = _ref.listingImage,
    listingImageLowResolution = _ref.listingImageLowResolution,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'allhomes-listing-card__image' : _ref$className,
    _ref$isResponsive = _ref.isResponsive,
    isResponsive = _ref$isResponsive === void 0 ? true : _ref$isResponsive,
    children = _ref.children;
  var getImage = clsName => ___EmotionJSX(MultiResolutionImage, {
    className: clsName,
    src: listingImage,
    srcLowResolution: listingImageLowResolution,
    alt: "property"
  });
  var getPlaceholder = clsName => ___EmotionJSX("img", {
    className: clsName,
    src: DefaultImage,
    alt: "property"
  });
  var images = isValid(listingImage) ? ___EmotionJSX(React.Fragment, null, isResponsive && getImage('img-square'), getImage('img-wide')) : ___EmotionJSX(React.Fragment, null, isResponsive && getPlaceholder('img-square-placeholder'), getPlaceholder('img-wide-placeholder'));
  return ___EmotionJSX("div", {
    className: classNames(className, {
      'is-default': !isValid(listingImage)
    }),
    css: styles.listingImage
  }, children, images);
};